<template>
<div class='general'>
    <linkbutton toplabel="Update Start Dates" @click="Start()" class="alertlink"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form >
                <div class="rightjustified">
                    <smallbutton @click="$refs.mymodal.closeModal()" toplabel='X' buttonclass="buttonclose" />
                </div>
                <label class="titlelabel">{{title}}</label>
                <div>
                    <label for="" class="pleasewait" v-if="pleaseWait">Please Wait...</label>
                </div>
                <div  class="mainform">
                    <div class="col">
                        
                       
                        <div class="entry">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">{{startDate1Text}}</label>
                            </div>
                            <input type="date" class="entrySelect"  v-model="thisStartDate" />
                        </div>
  
                        <div class="entry" v-if="showDate2">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">{{startDate2Text}}</label>
                            </div>
                            <input type="date" class="entrySelect"  v-model="thisStartDate2" />
                        </div>
                    </div>
  
                </div>
                <div >
                    <smallbutton  @click="save()" toplabel="Save" />
                    <smallbutton  @click="cancel()" toplabel="Cancel" />
                </div>

                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
          </form>

            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'

export default {
    name:'updatestartdate',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton

    },
    props:{
        person:{
            type:Object,
        }
    },
    mixins:[datamethods,format],
    data(){
        return{
            title:'Update Start Dates',
            message:'',
            

            pleaseWait:false,
            thisStartDate:null,
            thisStartDate2:null,    
        }
    },
    computed:{
      StartDate(){
          if(this.person.startDate==undefined){
              return this.$options.filters.formatDateForInputToday()
          }else{
              return this.$options.filters.formatDateForInput(this.person.startDate)
          }
      },
      StartDate2(){
          if(this.person.startDate2 ==undefined){
              return this.$options.filters.formatDateForInputToday()
          }else{
              return this.$options.filters.formatDateForInput(this.person.startDate2 )
          }
      },
      startDate1Text(){
            
            if(window.START_DATE1_TEXT==undefined){
                return 'Start Date'
            }else{return window.START_DATE1_TEXT}
        },
        startDate2Text(){
            
            if(window.START_DATE2_TEXT==undefined){
                return 'Start Date 2'
            }else{return window.START_DATE2_TEXT}
        },
        showDate2(){
            
            if(window.SHOW_DATE2==undefined){
                return false
            }else{return window.SHOW_DATE2}
        },
    },
    methods:{
        setDates(date1,date2){
            if(date1 ==undefined){
              this.thisStartDate= null
          }else{
              this.thisStartDate=  this.$options.filters.formatDateForInput(date1 )
          }
          if(date2 ==undefined){
              this.thisStartDate2=  null
          }else{
              this.thisStartDate2=  this.$options.filters.formatDateForInput(date2)
          }
        },
       
        async Start(){
           this.setDates(this.person.startDate, this.person.startDate2)
            this.message=''
            this.$refs.mymodal.openModal()
            
        },
        cancel(){
            this.$refs.mymodal.closeModal();
        },
        async save(){
      
            
            let req = {
                person:{
                    id:this.person.personId,
                    hireDate:this.thisStartDate,
                    initialHoursDate:this.thisStartDate2
                }
            }
            this.message=""
            this.pleaseWait=true;
            var response = await this.callAPI(req,'updatestartdate')
            if(response.Successful){
                console.log("stdt2 " + this.thisStartDate2)
                var havedate1 = this.thisStartDate!=null
                var havedate2  = this.thisStartDate2!=null

                this.thisStartDate=this.$options.filters.formatDateOutOfInput(this.thisStartDate)
                this.thisStartDate2=this.$options.filters.formatDateOutOfInput(this.thisStartDate2)
                this.message = "Start Date Updated"
                
                if(havedate1){
                    console.log('d1')
                    this.$emit('updated',this.person.personId,this.thisStartDate)
                }
                if(havedate2){
                    console.log('d2')
                    this.$emit('updated2',this.person.personId,this.thisStartDate2)
                }
                
                this.$refs.mymodal.closeModal();
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;

        },
    
        
        
       
    },

}
</script>

<style>
.mainform{
    
}
.general{
    font-size:medium;
}
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.imgbutton{
    background-color:var(--button-color);
    color:var(--light-text-color);
    border: none;
    border-radius:10px;
    min-width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
  position:relative;
}
.imgbutton:hover{
    background-color:var(--highlight-color);
  cursor:pointer;
}
.icondiv{
    background-color:blue;
    background:transparent;
}
.icon{
    background:transparent;
    max-width: 250px;;
}
.col{
    padding:20px;
}
.entrycheck{
    text-align: left;
    width:100%;
    margin-top:7px;
    margin-bottom:7px;
}
.entrymulti{
    visibility: visible;
    font-size:inherit;
    margin:0px 5px 0px 5px;
    
    text-align:left;
    resize:none;
    min-height:50px;
    width:100%;
}
</style>





























